import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import moment from "moment";

import logo from "../../assets/images/logo.png";
import Loader from "../../components/Loader/Loader";
import { useAddNotificationMutation } from "../../services/notifications";

const RequestUpdatePage = () => {
	const [isLoading, setIsLoading] = useState(false);

	const [addNotification] = useAddNotificationMutation();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		sendNotification();
	}, []);

	const sendNotification = async () => {
		setIsLoading(true);
		try {
			const type = searchParams.has("loadId") ? "load" : "asset";
			const assetId = searchParams.get("assetId");
			const loadId = searchParams.get("loadId");
			const loadNum = searchParams.get("loadNum");

			const timezone = moment.tz(moment.tz.guess()).format("z");

			await addNotification({
				type,
				loadId,
				assetId,
				notes: `Broker Requested Update at ${moment()
					.utc()
					.format("h:mm A")} ${timezone} for load #${loadNum}`,
				isView: false,
				sentBy: searchParams.get("createdBy"),
			});
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	if (isLoading) {
		return <Loader />;
	}

	return (
		<Box
			sx={{
				height: "100vh",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				background: "linear-gradient(135deg, #181DD9 30%, #9B8FEF 100%)",
			}}
		>
			<img
				src={logo}
				alt="Logo"
				style={{
					width: "100%",
					maxWidth: "720px",
					height: "auto",
					marginBottom: 20,
				}}
			/>
			<Typography
				variant="h4"
				component="h1"
				sx={{
					color: "white",
					textAlign: "center",
					maxWidth: "720px",
					width: "100%",
					padding: "10px",
					whiteSpace: "nowrap",
				}}
			>
				Your request has been forwarded to the carrier! <br /> They will get back to you ASAP!
			</Typography>
		</Box>
	);
};

export default RequestUpdatePage;
